import CustomInputBox from "../../../components/Input";
import { ResponsiveState } from "../../../utils/responsiveState";
import { useState, useEffect, useRef } from "react";
import {
  POST_ADD_BANK_DETAILS,
  LARGE_LOGO,
  COMPANY_NAME,
} from "../../../utils/ApiUrls";
import { useNavigate } from "react-router-dom";
import { POST } from "../../../utils/webService";
import { toast } from "react-hot-toast";
import { Spinner } from "../../../components/Spinner";
import OneButton from "../../../components/Button/OneButton";
import sessionManager from "../../../utils/sessionManager";
import SuccessTickGif from "../../../assets/tick.gif";
const modalTitle = () => {
  return (
    <div className="product-box flex justify-between items-center w-full h-[60px] absolute top-0">
      <img
        className="my-auto ml-6  h-[25px] object-contain"
        src={LARGE_LOGO}
        alt="Company Logo"
      />
    </div>
  );
};
const WalletDetails = () => {
  const { isLgScreen, isMdScreen } = ResponsiveState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [accountName, setAccountName] = useState<any>();
  const [bankName, setBankName] = useState<any>();
  const [branchName, setBranchName] = useState<any>();
  const [accountType, setAccountType] = useState<any>();
  const [ifscCode, setIfscCode] = useState<any>();
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef<Array<HTMLInputElement | null>>([]);
  const [otpError, setOtpError] = useState("");
  const [minutes, setMinutes] = useState(2);
  const [seconds, setSeconds] = useState(46);
  const [canResend, setCanResend] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [accountError, setAccountError] = useState("");
  const [ifscError, setIfscError] = useState("");
  const isValidAccountNumber = (value: string) => {
    return /^\d{9,18}$/.test(value);
    // usually bank accounts are 9–18 digits
  };
  const isValidIFSC = (value: string) => {
    return /^[A-Z]{4}0[A-Z0-9]{6}$/.test(value);
    // IFSC format: ABCD0XXXXXX
  };
  const [currentScreen, setCurrentScreen] = useState<
    "bank" | "otp" | "success"
  >("bank");
  // Helper functions
  const formatTimer = () => {
    const min = minutes < 10 ? `0${minutes}` : minutes;
    const sec = seconds < 10 ? `0${seconds}` : seconds;
    return `${min}:${sec}`;
  };
  const formatMobileNumber = (number: string) => {
    if (!number || number.length < 4) return number;
    const last4 = number.slice(-4);
    const first2 = number.slice(0, 2);
    return `${first2}*** ***${last4}`;
  };
  const handleOtpChange = (value: string, index: number) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);
    setOtpError("");
    // Auto-focus next input
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  const handleOtpKeyDown = (e: React.KeyboardEvent, index: number) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
  const isSendOtpDisabled =
    !accountName || !ifscCode || !!accountError || !!ifscError;
  const verifyOtp = async () => {
    const otpString = otp.join("");
    if (otpString.length !== 6) {
      setOtpError("Please enter 6 digit OTP");
      return;
    }
    setLoading(true);
    setOtpError("");
    const payload = {
      bankAccountHolderName: "",
      ifscCode,
      bankAccountNumber: accountName,
      otp: otpString,
    };
    const res = await POST(POST_ADD_BANK_DETAILS, payload);
    if (res?.data?.success) {
      setCurrentScreen("success");
      setLoading(false);
    } else {
      setOtpError(res?.data?.message || "Invalid OTP");
      setOtp(new Array(6).fill(""));
      inputRefs.current?.[0]?.focus();
      setLoading(false);
    }
  };
  const handleResendOtp = async () => {
    setCanResend(false);
    setMinutes(2);
    setSeconds(46);
    setOtp(new Array(6).fill(""));
    setOtpError("");
    // Call postAccountDetails to resend OTP
    setLoading(true);
    const getBankPayload = () => ({
      bankName: bankName,
      branchName: branchName,
      bankAccountHolderName: "",
      ifscCode: ifscCode,
      accountType: accountType,
      bankAccountNumber: accountName,
    });
    const payload = getBankPayload();
    const datas = await POST(POST_ADD_BANK_DETAILS, payload);
    if (datas?.data?.success) {
      const { sellerInfo } = sessionManager({});
      setMobileNumber(sellerInfo?.contactNumber || "");
      setMinutes(2);
      setSeconds(46);
      setCanResend(false);
      setOtpError("");
      setOtp(new Array(6).fill(""));
      setLoading(false);
      toast.success("OTP resent successfully");
    } else {
      toast.error(datas?.data?.message);
      setLoading(false);
    }
  };
  // Timer effect
  useEffect(() => {
    if (currentScreen !== "otp") return;
    if (minutes === 0 && seconds === 0) {
      setCanResend(true);
      return;
    }
    const interval = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds > 0) {
          return prevSeconds - 1;
        } else {
          setMinutes((prevMinutes) => {
            if (prevMinutes > 0) {
              return prevMinutes - 1;
            } else {
              setCanResend(true);
              return 0;
            }
          });
          return 59;
        }
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [currentScreen, minutes, seconds]);
  const WalletBankDetails = () => {
    //getting the sellerID
    // const sellerId = localStorage.getItem("sellerId");
    const { sessionId, sellerInfo } = sessionManager({});
    const sellerId = sellerInfo?.sellerId;
    const postAccountDetails = async () => {
      setAccountError("");
      setIfscError("");
      if (!accountName || !isValidAccountNumber(accountName)) {
        setAccountError("Enter a valid account number");
        return;
      }
      if (!ifscCode || !isValidIFSC(ifscCode)) {
        setIfscError("Enter a valid IFSC code");
        return;
      }
      setLoading(true);
      const getBankPayload = (otpValue?: string) => ({
        bankName: bankName,
        branchName: branchName,
        bankAccountHolderName: "",
        ifscCode: ifscCode,
        accountType: accountType,
        bankAccountNumber: accountName,
        ...(otpValue ? { otp: otpValue } : {}),
      });
      const payload = getBankPayload();
      const datas = await POST(POST_ADD_BANK_DETAILS, payload);
      console.log("datas", datas);
      if (datas?.data?.success) {
        // Get mobile number from seller info
        const { sellerInfo } = sessionManager({});
        setMobileNumber(sellerInfo?.contactNumber || "");
        setCurrentScreen("otp");
        setMinutes(5);
        setSeconds(0);
        setCanResend(false);
        setOtpError("");
        setOtp(new Array(6).fill(""));
        setLoading(false);
        window?.dataLayer?.push({
          event: "seller_bank_verification",
          sellerId: sellerId,
          seller_bank_verification: true,
        });
      } else {
        toast.error(datas?.data?.message);
        setLoading(false);
      }
    };
    return (
      <div
        className={`${
          isMdScreen ? " m-auto !w-[500px]  !h-[600px] " : "w-full !h-full"
        }flex flex-col justify-center relative md:px-0 md:gap-y-0`}
      >
        <div className={`${isMdScreen ? "custom_shadow h-full" : ""}`}>
          {modalTitle()}
          <div className="customScroll ">
            <div className="text-center md:mt-24 mb-[44px]  mt-[108px]">
              <h1 className="font-Lato text-[22px] font-bold leading-7 text-center">
                {currentScreen === "bank"
                  ? `Welcome to ${COMPANY_NAME}`
                  : currentScreen === "otp"
                    ? "OTP Verification"
                    : "Verification Successful!"}
              </h1>
              <p className="mt-3 text-[16px] font-light leading-[22px] text-[#494949] font-Open">
                {currentScreen === "bank"
                  ? "Please fill your bank details"
                  : currentScreen === "otp"
                    ? `Enter the OTP sent to your mobile number ending with ${formatMobileNumber(String(mobileNumber))}`
                    : "Bank details have been updated successfully"}
              </p>
            </div>
            <div className="flex flex-col items-center mx-5 md:mx-[90px] ">
              {/* ================= BANK DETAILS FORM ================= */}
              {currentScreen === "bank" && (
                <>
                  <div className="w-full">
                    <CustomInputBox
                      containerStyle="!w-full"
                      value={accountName || ""}
                      inputMode="numeric"
                      label="Enter Account No"
                      className="!w-full"
                      maxLength={50}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setAccountName(value);
                        if (!value) {
                          setAccountError("Account number is required");
                        } else if (!isValidAccountNumber(value)) {
                          setAccountError("Account number must be 9–18 digits");
                        } else {
                          setAccountError("");
                        }
                      }}
                      id="accountNumber"
                    />
                    {accountError && (
                      <p className="text-red-500 text-xs mt-1">
                        {accountError}
                      </p>
                    )}
                  </div>
                  <div className="w-full">
                    <CustomInputBox
                      label="Enter IFSC Code"
                      containerStyle="!w-full mt-4"
                      maxLength={11}
                      value={ifscCode}
                      inputType="text"
                      id="ifscCode"
                      className="!w-full"
                      onChange={(e) => {
                        const value = e.target.value.toUpperCase();
                        setIfscCode(value);
                        if (!value) {
                          setIfscError("IFSC code is required");
                        } else if (value.length < 11) {
                          setIfscError("IFSC must be 11 characters");
                        } else if (!isValidIFSC(value)) {
                          setIfscError(
                            "Invalid IFSC format (e.g. HDFC0ABC123)",
                          );
                        } else {
                          setIfscError("");
                        }
                      }}
                    />
                    {ifscError && (
                      <p className="text-red-500 text-xs mt-1">{ifscError}</p>
                    )}
                  </div>
                  <div className="mt-6 flex justify-end gap-3">
                    <OneButton
                      text="CANCEL"
                      onClick={() => navigate(-1)}
                      variant="primary"
                    />
                    <OneButton
                      text="SEND OTP"
                      onClick={postAccountDetails}
                      variant="secondary"
                      disabled={isSendOtpDisabled}
                    />
                  </div>
                </>
              )}
              {/* ================= OTP SCREEN ================= */}
              {currentScreen === "otp" && (
                <>
                  {/* Error Message */}
                  {otpError && (
                    <div className="w-full bg-red-50 border border-red-200 rounded-lg p-3 mb-4 flex items-center gap-2">
                      <svg
                        className="w-5 h-5 text-red-600 flex-shrink-0"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <p className="text-red-600 text-sm font-Open">
                        {otpError}
                      </p>
                    </div>
                  )}
                  {/* OTP Input Boxes */}
                  <div className="w-full flex justify-center gap-2 mb-4">
                    {otp.map((digit, idx) => (
                      <input
                        key={idx}
                        ref={(el) => (inputRefs.current[idx] = el)}
                        type="text"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleOtpChange(e.target.value, idx)}
                        onKeyDown={(e) => handleOtpKeyDown(e, idx)}
                        className="w-12 h-12 text-center text-lg border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    ))}
                  </div>
                  {/* Timer */}
                  <div className="w-full text-center mb-4">
                    <p className="font-Open text-sm text-[#494949]">
                      {formatTimer()}
                    </p>
                  </div>
                  {/* Resend OTP */}
                  <div className="w-full text-center mb-6">
                    <p className="font-Open text-xs text-[#494949] mb-1">
                      Didn't receive the OTP?
                    </p>
                    {canResend ? (
                      <button
                        onClick={handleResendOtp}
                        className="text-[#004EFF] font-Open text-sm font-semibold cursor-pointer hover:underline"
                      >
                        RESEND
                      </button>
                    ) : (
                      <p className="text-gray-400 font-Open text-sm">RESEND</p>
                    )}
                  </div>
                  <div className="mt-6 flex justify-end gap-3">
                    <OneButton
                      text="CANCEL"
                      onClick={() => {
                        setCurrentScreen("bank");
                        setOtpError("");
                        setOtp(new Array(6).fill(""));
                      }}
                      variant="primary"
                    />
                    <OneButton
                      text="VERIFY OTP"
                      onClick={verifyOtp}
                      variant="secondary"
                      disabled={otp.some((d) => d === "") || loading}
                    />
                  </div>
                </>
              )}
              {/* ================= SUCCESS SCREEN ================= */}
              {currentScreen === "success" && (
                <>
                  <div className="flex flex-col items-center justify-center w-full">
                    {/* Success Icon */}
                    <img
                      src={SuccessTickGif}
                      alt="success"
                      height={120}
                      width={120}
                      className="mb-6"
                    />
                    {/* Success Message */}
                    <div className="flex flex-col items-center mb-6">
                      <p className="font-Open text-lg font-bold text-[#1C1C1C] mb-2">
                        Verification Successful!
                      </p>
                      <p className="font-Open text-sm text-[#494949] text-center">
                        Bank details have been updated successfully
                      </p>
                    </div>
                    {/* Close Button */}
                    <OneButton
                      text="Close"
                      onClick={() => {
                        navigate("/dashboard/overview");
                      }}
                      className="bg-[#1C1C1C] text-white text-sm py-2 px-4 !rounded-[20px] font-Open font-semibold"
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      {loading ? (
        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <Spinner />
        </div>
      ) : isMdScreen ? (
        <div className="flex h-[100vh]">{WalletBankDetails()}</div>
      ) : (
        WalletBankDetails()
      )}
    </>
  );
};
export default WalletDetails;
